import { render, staticRenderFns } from "./SearchCriterioItemList.vue?vue&type=template&id=086ec38c&scoped=true&"
import script from "./SearchCriterioItemList.vue?vue&type=script&lang=js&"
export * from "./SearchCriterioItemList.vue?vue&type=script&lang=js&"
import style0 from "./SearchCriterioItemList.vue?vue&type=style&index=0&id=086ec38c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086ec38c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib'
installComponents(component, {
  VIcon,
})
